import cn from 'classnames';
import Link from 'next/link';

import { useUserAgent } from '@/contexts/UserAgentContext';

import styles from './styles.module.scss';
import { Props } from './types';

const FooterLinks = ({ label, data }: Props) => {
  const { isMacOS, isAndroid } = useUserAgent();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div className={styles.container}>
      <p
        className={cn(styles.label, {
          [styles.avenirFont]: isMacOS || isAndroid,
        })}
      >
        {label}
      </p>
      {data.map(item => {
        return (
          <Link
            key={item.id}
            href={item.URL}
            className={styles.link}
            onClick={scrollToTop}
            target={item.target ? item.target : ''}
          >
            {item.Nazwa}
          </Link>
        );
      })}
    </div>
  );
};

export default FooterLinks;
